var _defs, _circle, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8991b;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200,
    cy: 200,
    r: 200
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 133.19,
    y: 129.93,
    width: 158.39,
    height: 33.89,
    rx: 8.6,
    ry: 8.6,
    transform: "translate(38.77 -44.27) rotate(13.09)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 121.04,
    y: 182.2,
    width: 158.39,
    height: 33.89,
    rx: 8.6,
    ry: 8.6,
    transform: "translate(50.29 -40.16) rotate(13.09)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.43,
    y: 236.45,
    width: 158.39,
    height: 33.89,
    rx: 8.6,
    ry: 8.6,
    transform: "translate(62.24 -35.9) rotate(13.09)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201.93,
    y: 76.02,
    width: 45.96,
    height: 33.89,
    rx: 8.6,
    ry: 8.6,
    transform: "translate(83.44 290.98) rotate(-76.91)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.17,
    y: 290.1,
    width: 45.96,
    height: 33.89,
    rx: 8.6,
    ry: 8.6,
    transform: "translate(-163.57 408.13) rotate(-76.91)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.c177caea225585a63029b0404e38efda.svg";
export { ForwardRef as ReactComponent };